import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // Guardar la preferencia de idioma en localStorage
    localStorage.setItem('i18nextLng', lng);
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-xs text-gray-500 dark:text-gray-400">Idioma:</span>
      <div className="flex space-x-1">
        <button
          className={`px-2 py-1 text-xs rounded-md transition-colors ${
            i18n.language === 'es' || i18n.language.startsWith('es-')
              ? 'bg-domired-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
          onClick={() => changeLanguage('es')}
        >
          Español
        </button>
        <button
          className={`px-2 py-1 text-xs rounded-md transition-colors ${
            i18n.language === 'en' || i18n.language.startsWith('en-')
              ? 'bg-domired-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
          onClick={() => changeLanguage('en')}
        >
          English
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector;
